import apiService from '../baseApiService';

const userService = {
    getMyKyc: async () => {
        return await apiService.get(`/v1/userkyc`);
    },
};

export default userService;
